import type { Feature } from '@luna/gatekeeper';

export const cardLimitsFocusPage: Feature = {
    enabled: false,
    _description: 'Displays the newly refactored Card Limits focus page which replaces the modal',
};
